/**
 * Generato automaticamente.
 * framework-cfg-utenti
 */

export type EnumTagSemanticoDTOTipo =
  (typeof EnumTagSemanticoDTOTipo)[keyof typeof EnumTagSemanticoDTOTipo];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnumTagSemanticoDTOTipo = {
  TEXT: 'TEXT',
  NUMERIC: 'NUMERIC',
  DATE: 'DATE',
  BOOLEAN: 'BOOLEAN',
  GEOMETRY: 'GEOMETRY',
  FILE: 'FILE',
  MAPPA: 'MAPPA',
} as const;
